import SettingController from "./SettingController";
import PlatformPeg from "../../PlatformPeg";
import { type SettingLevel } from "../SettingLevel";

export default class ReloadOnChangeController extends SettingController {
    public onChange(level: SettingLevel, roomId: string, newValue: any): void {
        PlatformPeg.get()?.reload();
    }
}
